import { types } from "../types/types";


export const notification = body => ({
    type: types.notification,
    payload: body
})